import React from "react";
import { useParams } from "react-router-dom";
import { DocHub } from "../components/DocHub";
import { AFFILIATE_DOCS } from "../data/affiliateDocs";

export const AffiliateDocs = () => {
  const { slug } = useParams();
  return (
    <DocHub
      eyebrow="TAVEN Affiliate Program"
      title="Official Affiliate Documentation"
      subtitle="The complete TAVEN SYSTEM LLC affiliate program documentation — partnership options, compensation, leadership, compliance, and corporate declarations."
      docs={AFFILIATE_DOCS}
      basePath="/affiliate-program/documents"
      activeSlug={slug}
      footerNote="Draft business documents for the TAVEN ecosystem. No income is guaranteed — see the Earnings Disclaimer. TAVEN SYSTEM LLC — Build. Earn. Grow. Leave a Legacy."
    />
  );
};

export default AffiliateDocs;
